// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__dnDM3","active":"NavigationItem_active__1tnQY"};